import { Link } from "react-router-dom";
import useMainMenu from "../../api/useMainMenu";
import noImage from "../../images/icons/noImage.png";
import Loader from "../Loader/Loader";
import { LazyLoadImage } from "react-lazy-load-image-component";
import loaderGif from '../../images/Loading_2.gif'

export default function ProductMarkup({ path, type, filter }) {
  const { mainMenu, isLoading } = useMainMenu(type);

  const menu = mainMenu;

  if (isLoading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  if (!isLoading) {
    return (
      <div className="container">
        <ul className="productMarkup">
          {(filter || menu)?.map((item) => (
            <li key={item.id} className="productMarkup__item">
              <Link to={`${path}/${item.id}`}>
                <div className="productMarkup__item--img">
                  <LazyLoadImage src={item.imageLinks[0] || noImage} placeholderSrc={loaderGif} alt="страва" />
                </div>

                <div className="productMarkup__item--text">
                  <p className="productMarkup__item--title">{item.name}</p>
                  <p className="productMarkup__item--desc">
                    {item.description.substr(0, 100) || "Тут має бути опис"}...
                  </p>
                  <div className="productMarkup__item--other">
                    <p className="productMarkup__item--price">
                      {item.sizePrices[0].price.currentPrice} грн
                    </p>
                    <p className="productMarkup__item--weight">
                      {item.weight} грам
                    </p>
                    {/* <p className="productMarkup__item--time"></p> */}
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
